export default [
  {
    id: 0,
    fullName: 'I am dev',
    email: 'dev@test.com',
    phone: '012345678',
  },
  {
    id: 1,
    fullName: 'I am designer',
    email: 'designer@test.com',
    phone: '12324234234',
  },
  {
    id: 3,
    fullName: 'I am QA/QC',
    email: 'qa.qc@test.com',
    phone: '456789012',
  },
  {
    id: 4,
    fullName: 'I am project manager',
    email: 'project.manager@test.com',
    phone: '876543210',
  },
  {
    id: 5,
    fullName: 'I am product manager',
    email: 'product.manager@test.com',
    phone: '31389123012',
  },
];
